// src/store/bet/betSelectors.ts
import { pipe, Array as A, Option as O } from 'effect'
import type { Bet } from 'src/types/domain/Bet'
import type { BetState } from '../bet'

export const getBetsByGameAndPlayer = (
  state: BetState,
  gameId: string,
  playerId: string
): Bet[] =>
  pipe(
    state.bets.allIds,
    A.map((id) => state.bets.byId[id]),
    A.map(O.fromNullable),
    A.getSomes,
    A.filter((bet) => bet.raceConfigurationId === gameId && bet.playerId === playerId)
  )
